// extracted by mini-css-extract-plugin
export var border = "sectionTitle-module--border--RuZkG";
export var title = "sectionTitle-module--title--WFMBo";
export var wrapper = "sectionTitle-module--wrapper--1lPqG";